import styled from 'styled-components';

export const WrapperBox = styled.div(
  props => `
    border:1px solid #e1e1e1;
    border-radius: 3px;
    width: 21rem;
    display:flex;
    background: white;
    flex-direction: column;
    height: 270px;
    overflow-y: scroll;
    
    &::-webkit-scrollbar {
        width: 3px;
    }
    
    &::-webkit-scrollbar-track {
        background: #fff; 
    }
    
    &::-webkit-scrollbar-thumb {
        background: #e1e1e1; 
        border-radius: 20px;
    }
`,
);
